import { gql } from '@apollo/client';

/**
 * 提交订单批量导出任务。
 *
 * trackingNumbers 非空 = 导勾选，为空 = 按 filter 导全部；channelId 与操作人取自登录态，不接受入参。
 *
 * 导出文件的行序<b>不作保证</b>（PRD 未要求，客户可在 Excel 里自行排序），因此 trackingNumbers
 * 的顺序不影响正确性，直接把 antd 的 selectedRowKeys 发过去即可。实际表现是：服务端按 500 切片、
 * 片内恒 id 倒序，故勾选数 ≤ 500 时整份文件也是 id 倒序，超过时呈分段递减。
 */
export const PORTAL_EXPORT_ORDERS = gql`
    mutation PortalExportOrders(
        $trackingNumbers: [String!]
        $filter: PortalOrderFilter
        $timeZone: String!
        $uiLanguage: String!
    ) {
        portalExportOrders(
            trackingNumbers: $trackingNumbers
            filter: $filter
            timeZone: $timeZone
            uiLanguage: $uiLanguage
        ) {
            success
            taskId
            errorCode
            messageKey
        }
    }
`;
